import { ProblemDetails } from ".";

const isApiLimitError = (err: ProblemDetails) =>
  err?.type && (err?.type == "1001" || err?.type == "1002");

export default isApiLimitError;
